import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { baseURL } from "../../Config/config";
import { displayAlert } from "../../helpers/alert";

const initFormErrors = {
  new_password: "",
  confirm_password: "",
};

export default function UpdatePassword() {
  const navigate = useNavigate();
  const [user, setUser] = useState();
  const [formErrors, setFormErrors] = useState(initFormErrors);

  async function save() {
    setFormErrors(initFormErrors);
    await axios
      .put(`${baseURL}/users/password/update`, user)
      .then((response) => {
        if (response.data.error) return;
        displayAlert("success", response.data.message, "");
        navigate("/");
      })
      .catch((err) => {
        setFormErrors({ ...initFormErrors, ...err.response.data });
        displayAlert("error", "Erreur est survenue !", "Veuiller réessayer !");
      });
  }
  return (
    <>
      <div className="breadcrumbs">
        <div className="breadcrumbs-inner">
          <div className="row m-0">
            <div className="col-sm-12">
              <div className="page-header float-left">
                <div className="page-title">
                  <h1>Modifier Votre mot de passe </h1>
                </div>
              </div>
            </div>
            <div className="col-sm-8"></div>
          </div>
        </div>
      </div>
      <div className="content">
        <div className="animated">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="form-group col-md-6 col-12">
                  <label htmlFor="password" className=" form-control-label">
                    Nouveau mot de passe
                  </label>
                  <input
                    type="text"
                    onChange={(e) => {
                      setUser((prevState) => ({
                        ...prevState,
                        new_password: e.target.value,
                      }));
                    }}
                    id="password"
                    placeholder="Enter le mot de passe"
                    className={
                      formErrors.new_password !== ""
                        ? "form-control border-danger"
                        : "form-control"
                    }
                  />
                  <small>
                    <code>{formErrors.new_password}</code>
                  </small>
                </div>
                <div className="form-group col-md-6 col-12">
                  <label
                    htmlFor="confirm_password"
                    className=" form-control-label"
                  >
                    Confirmer mot de passe
                  </label>
                  <input
                    type="text"
                    onChange={(e) => {
                      setUser((prevState) => ({
                        ...prevState,
                        confirm_password: e.target.value,
                      }));
                    }}
                    id="confirm_password"
                    placeholder="Confirmer mot de passe"
                    className={
                      formErrors.confirm_password !== ""
                        ? "form-control border-danger"
                        : "form-control"
                    }
                  />
                  <small>
                    <code>{formErrors.confirm_password}</code>
                  </small>
                </div>
              </div>
              <hr />
              <div className="d-flex flex-row-reverse text-right">
                <button
                  type="button"
                  onClick={save}
                  className="btn btn-primary btn-sm mx-2"
                >
                  Enregistrer
                </button>
                <Link
                  className="btn btn-link btn-sm text-secondary mx-2"
                  to={"/users"}
                >
                  Annuler
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
